export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_GET_TOKEN = 'AUTH_GET_TOKEN';
export const AUTH_UPDATE_TOKEN = 'AUTH_UPDATE_TOKEN';
